<script setup>
import { onMounted, ref } from 'vue';
import { fetchData } from '../../fetchData';
import ProductCategoryItem from './ProductCategoryItem.vue';
import ProductCategoryItemSkeleton from './ProductCategoryItemSkeleton.vue';

const productCategories = ref([]);
const loading = ref(true);
const loadingMore = ref(false);
const error = ref(null);
const scrollContainer = ref(null);

const fetchProductCategories = async () => {
    error.value = null;

    try {
        const { result = {} } = await fetchData(`/api/v1/product-categories?limit=100`);
        productCategories.value = result.data
        loading.value = false
    } catch (e) {
        error.value = 'Failed to load breaking news: ' + e.message;
    }
};

onMounted(() => {
    fetchProductCategories();
});
</script>

<template>
    <div ref="scrollContainer" class="mt-2 overflow-y-auto h-full">
        <div v-if="loading" class="space-y-2">
            <ProductCategoryItemSkeleton v-for="n in 4" :key="`sk-load-${n}`" />
        </div>
        <div v-else-if="error" class="text-center text-red-500 py-4">
            {{ error }}
        </div>
        <div v-else-if="productCategories.length === 0" class="text-center text-gray-500 py-4">
            No products available.
        </div>
        <div v-else class="space-y-2">
            <ProductCategoryItem v-for="productCategory in productCategories" :key="productCategory.id"
                :data="productCategory" />
        </div>
        <div v-if="loadingMore" class="space-y-2 mt-2">
            <ProductCategoryItemSkeleton key="sk-more" />
        </div>
    </div>
</template>
